import {
  DashboardShortcutCard as DSCCard,
  DashboardShortcutCardContent,
  DashboardShortcutCardHat,
  DashboardShortcutCardHeader,
  DashboardShortcutCardImg,
  DashboardShortcutCardImgWrapper,
  DashboardShortcutCardLiveDot,
  DashboardShortcutCardText,
  DashboardShortcutCardTitle
} from '@/components/custom/dashboard';
import { useNavigate } from 'react-router-dom';

export default function DashboardShortcutCard({ source, type, title, link, text }) {
  const navigate = useNavigate();

  return (
    <DSCCard onClick={() => navigate(link)}>
      <DashboardShortcutCardContent>
        <DashboardShortcutCardHeader>
          <DashboardShortcutCardHat title={type}>{type}</DashboardShortcutCardHat>
          <DashboardShortcutCardTitle title={title}>{title}</DashboardShortcutCardTitle>
        </DashboardShortcutCardHeader>

        <DashboardShortcutCardText title={text}>{text}</DashboardShortcutCardText>
      </DashboardShortcutCardContent>

      <DashboardShortcutCardImgWrapper>
        {type === 'Aula ao vivo' && <DashboardShortcutCardLiveDot />}

        <DashboardShortcutCardImg
          src={source}
          alt=""
        />
      </DashboardShortcutCardImgWrapper>
    </DSCCard>
  );
}
